import { render } from "./Popover.vue?vue&type=template&id=3c3261fb&scoped=true&ts=true"
import script from "./Popover.vue?vue&type=script&lang=ts"
export * from "./Popover.vue?vue&type=script&lang=ts"

import "./Popover.vue?vue&type=style&index=0&id=3c3261fb&lang=scss&scoped=true"
import "./Popover.vue?vue&type=style&index=1&id=3c3261fb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3261fb"]])

export default __exports__